import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import DataTable from "../../lib/DataTable";
import { Notice, Stat } from "../../lib/ui";

/* Pending GRN payments – port of payableList.php (API: /api/payables). "Pay" opens the supplier payment page. */

export default function Payables() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/payables").then(setRows).catch((e) => setError(e.message)); }, [api]);
  const columns = [
    { key: "payment_date", label: "Date" }, { key: "po_id", label: "PO #", num: true },
    { key: "client_name", label: "Supplier", render: (r) => <b style={{ color: "var(--ink)" }}>{r.client_name}</b> }, { key: "contact_phone", label: "Phone" },
    { key: "grn_amount", label: "GRN amount", num: true, render: (r) => n2(r.grn_amount) }, { key: "payment_done", label: "Paid", num: true, render: (r) => n2(r.payment_done) },
    { key: "balance", label: "Balance", num: true, render: (r) => <b>{n2(r.balance)}</b> },
    { key: "status", label: "Status", render: (r) => <span className={`pill-tag ${r.status === "Unpaid" ? "err" : "warn"}`}>{r.status}</span> },
    { key: "pay", label: "", sortable: false, render: (r) => <Link className="btn sm primary" to={`/make_grn_payment?po_id=${r.po_id}`}>Make payment</Link> },
  ];
  const owed = (rows || []).reduce((s, r) => s + r.balance, 0);
  return (
    <main className="pg">
      <PageHeader slug="payableList" />
      <Notice notice={error && { tone: "err", text: error }} />
      {rows && <div className="ui-stats"><Stat icon="fa-file-invoice-dollar" tone="warn" label="GRNs not fully paid" value={rows.length} /><Stat icon="fa-coins" tone="danger" label="Owed to suppliers" value={n2(owed)} unit="TZS" /></div>}
      <section className="panel">{rows ? <DataTable columns={columns} rows={rows} rowKey={(r) => r.payment_id} searchPlaceholder="Search supplier or PO" initialSort={{ key: "payment_date", dir: -1 }} empty="No pending GRN payments." />
        : !error && <div className="empty"><i className="fas fa-spinner fa-spin" />Loading…</div>}</section>
    </main>
  );
}
